module.exports = __webpack_public_path__ + "img/highlight-their-gain.aa60c0fe.svg";